import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BatchImportModel } from '@data-layer/models/common';
import { BatchImportService } from '@shared/batch-import-mutual/services';
import { enumBatchImportItemType } from '@data-layer/enums/common';

@Component({
  selector: 'batch-process-partial-list-notification',
  templateUrl: './batch-process-partial-list-notification.component.html',
  styleUrls: ['./batch-process-partial-list-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchProcessPartialListNotificationComponent {
  @Input() public batchItem: BatchImportModel;
  @Input() public payedBatchItems: number = 0;

  public isShow: boolean = true;

  constructor(private batchImportService: BatchImportService) {}

  public onReload(): void {
    this.batchImportService.openSidebar(this.batchItem);
  }

  public get paymentCountStr(): string {
    return this.payedBatchItems > 1 ? 'BATCH_AFTER_PAYMENT_STEP_SUCCESS_PLURAL' : 'BATCH_AFTER_PAYMENT_STEP_SUCCESS_SINGLE';
  }

  public get isISFBatchItem(): boolean {
    if (!this.batchItem) {
      return;
    }

    return this.batchItem.itemType === enumBatchImportItemType.ISF;
  }
}
